// extracted by mini-css-extract-plugin
export var flexSection = "footer-module--flexSection--5fc07";
export var footerContainer = "footer-module--footerContainer--61a23";
export var footerSection = "footer-module--footerSection--fd05a";
export var logoImage = "footer-module--logoImage--092dd";
export var row = "footer-module--row--00182";
export var social_area = "footer-module--social_area--9018b";
export var social_icons = "footer-module--social_icons--bb615";